<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
          <el-row :gutter="20">
            <el-col :span="2">
              <el-button type="primary" round size="mini" @click="newCustomerInfo()" :disabled="!pagePermissionObj.newCustomerInfo">添加客户</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="danger" round size="mini" @click="delCustomer()" :disabled="!pagePermissionObj.delCustomer">删除客户</el-button>
            </el-col>
            <el-col :span="3">
              <el-tooltip class="item" effect="light" content="客户ID" placement="top">
                <el-input v-model="queryInfo.customerId" placeholder="客户ID" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户姓名" placement="top">
                <el-input v-model="queryInfo.customerName" placeholder="客户姓名" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户电话" placement="top">
                <el-input v-model="queryInfo.customerPhone" placeholder="客户电话" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="客户地址" placement="top">
                <el-input v-model="queryInfo.customerAddr" placeholder="客户地址" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="提交人" placement="top">
                <el-input v-model="queryInfo.submitter" placeholder="提交人" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="搜索或保留条件刷新,可在页面中使用回车键代替" placement="top">
                <el-button icon="el-icon-search" circle size="mini" @click="search"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          
          <el-table max-height="630" :data="customerInfoList" border style="width: 100%" size="mini"
            ref="multipleTable" tooltip-effect="dark" :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange" @row-click="handleRowClick">
            <el-table-column type="selection" width="37"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="customerId" label="客户ID" width="100%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="customerName" label="客户姓名" width="90%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="customerPhone" label="客户电话"></el-table-column>
            <el-table-column prop="customerAddr" label="收货地址"></el-table-column>
            <el-table-column prop="submitter" label="提交人"></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100%">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="editCustomerInfo(scope.$index, scope.row)" :disabled="!pagePermissionObj.editCustomerInfo">修改</el-button>
              </template>
            </el-table-column>
            
          </el-table>
    
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10,20,50,100,200,500]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
          
        </el-card>
        
        <dev>
          <!-- 添加或修改客户信息 -->
          <el-dialog :visible.sync="newOrEditCustomerInfoVisible" center width="30%">
            <el-form :model="customerInfo" ref="form" label-width="96px" size="mini">
              <el-form-item label="客户ID">
                <el-input v-model="customerInfo.customerId" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="客户姓名">
                <el-input v-model="customerInfo.customerName" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="客户电话">
                <el-input v-model="customerInfo.customerPhone" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="收货地址">
                <el-input v-model="customerInfo.customerAddr" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="提交人">
                <el-input v-model="customerInfo.submitter" style="width: 90%;"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="newOrEditCustomerInfoVisible = false">取 消</el-button>
              <el-button type="primary" @click="subCustomerInfo()" style="margin-left: 20%;">提交</el-button>
            </div>
          </el-dialog>
        </dev>
        
      </div>
      
    </template>
    
<script>
  export default {
    data() {
      return {
        pagePermissionObj: JSON.parse(window.localStorage.getItem("pagePermission")),
        queryInfo: {
          customerId: "",
          customerName: "",
          customerPhone: "",
          customerAddr: "",
          submitter: "",
          pageNum: 1,
          pageSize: 10
        },
        customerInfoList: [],
        total: 0,
        
        //新增或修改客户信息模态窗口
        newOrEditCustomerInfoVisible: false,
        customerInfo: {
          customerId: "",
          customerName: "",
          customerPhone: "",
          customerAddr: "",
          submitter: ""
        }
      };
    },
    methods: {
      async getCustomerInfoList()
      {
        const {data:res} = await this.$http.post('/api/customer-info/get', this.queryInfo)
        if (res.code==1){
          this.customerInfoList = res.data.dataList;
          this.total = res.data.total
          this.totalPag = res.data.totalPag;
        }
      },
      //添加客户信息
      newCustomerInfo(){
        this.customerInfo = {
          customerId: "",
          customerName: "",
          customerPhone: "",
          customerAddr: "",
          submitter: window.localStorage.getItem('userCompellation'),
          comCode: window.localStorage.getItem('userComCode'),
        };
        this.newOrEditCustomerInfoVisible = true;
      },
      //修改客户信息
      editCustomerInfo(index, customerInfo){
        this.customerInfo = customerInfo;
        this.newOrEditCustomerInfoVisible = true;
      },
      //提交客户信息
      async subCustomerInfo(){
        const {data:res} = await this.$http.post('/api/customer-info/createAndModif', this.customerInfo)
        if (res.code==1){
          if(this.customerInfo.id == undefined){
            this.$message({
              message: '添加客户信息成功！',
              type: 'success'
            });
          }else{
            this.$message({
              message: '修改客户信息成功！',
              type: 'success'
            });
          }
          
          this.newOrEditCustomerInfoVisible = false;
          
          this.getCustomerInfoList();
        }
        else
        {
          this.$message.error(res.msg)
        }
      },
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getCustomerInfoList();
      },
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getCustomerInfoList();
      },
      //搜索
      search()
      {
        this.getCustomerInfoList();
      },
      //批量删除客户
      delCustomer()
      {
       
        if(this.multipleSelection==undefined || this.multipleSelection.length == 0){
         this.$message.error('请选择要删除的客户！');
         return;
        } 
        
        this.$confirm('确定删除 '+this.multipleSelection.length+' 个客户信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( async () => {
          
          let errorCount = "";
          
          for( let i = 0; i < this.multipleSelection.length; i++)
          {
            const {data:res} = await this.$http.delete('/api/customer-info/del/'+this.multipleSelection[i].id)
            if(res.code !== 1)
            { 
              errorCount += this.multipleSelection[i].customerId+", "
            }
          }
          
          if(errorCount == "")
          { 
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
          else
          {
            this.$message.error('删除完成！其中 '+errorCount+' 删除失败！');
          }
          
          this.getCustomerInfoList();
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消'
          });          
        });
      },
      // 选择
      handleSelectionChange(val) {
        this.multipleSelection = val;
        //console.log(val);
      },
      //点击行触发，选中或不选中复选框
      handleRowClick(row, column, event){
        this.$refs.multipleTable.toggleRowSelection(row);
      }
      
    },
    created() {
      this.getCustomerInfoList();
      
      var that = this
      //当前页面监视键盘输入
      document.onkeydown = function(e) {//事件对象兼容
          let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
          //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40;回车13
          //回车搜索
          if (e1 && e1.keyCode == 13) {
              that.search();
          }
          else if(e1 && e1.keyCode == 37)
          {
            if(that.queryInfo.pageNum > 1)
            {
              that.handleCurrentChange(that.queryInfo.pageNum - 1)
            }
          }
          else if(e1 && e1.keyCode == 39)
          {
            if(that.queryInfo.pageNum < that.totalPag)
            {
              that.handleCurrentChange(that.queryInfo.pageNum + 1)
            }
          }
      }
    }
  };
</script>

<style>
</style>
